export const solutionBuilder = () => {
    const solution = {
        addressLine: null,
        addressLine2: null,
        administrativeAreaName: null,
        administrativeAreaId: null,
        locality: null,
        postalCode: null,
        countryId: null,
        currencyId: null,
        totalBudget: null,
        contractorId: null,
        createProjects: [],

        setAddressLine(addressLine) {
            this.addressLine = addressLine
            return this;
        },

        setAddressLine2(addressLine2) {
            this.addressLine2 = addressLine2;
            return this;
        },

        setAdministrativeAreaId(administrativeAreaId) {
            this.administrativeAreaId = administrativeAreaId;
            return this;
        },

        setAdministrativeAreaName(administrativeAreaName) {
            this.administrativeAreaName = administrativeAreaName;
            return this;
        },

        setLocality(locality) {
            this.locality = locality;
            return this;
        },

        setPostalCode(postalCode) {
            this.postalCode = postalCode;
            return this;
        },

        setCountryId(countryId) {
            this.countryId = countryId;
            return this;
        },

        setCurrencyId(currencyId) {
            this.currencyId = currencyId;
            return this;
        },

        setTotalBudget(totalBudget) {
            this.totalBudget = totalBudget;
            return this;
        },

        setContractorId(contractorId) {
            this.contractorId = contractorId;
            return this;
        },

        setCreateProjects(createProjects) {
            this.createProjects = createProjects;
            return this;
        },

        addProject(createProject) {
            this.createProjects.push(createProject);
            return this;
        },

        build() {
            if (!this.createProjects.length) {
                throw Error(this.createProjects.toString());
            }
            if (this.addressLine === null) {
                delete this.addressLine;
            }
            if (this.addressLine2 === null) {
                delete this.addressLine2;
            }
            return this;
        },
    };

    return solution;
};